export interface Operator {
    display: string;
    apiSymbol: string;
    value: string | null;
}

const showAll = {
    display: 'Show all',
    apiSymbol: '',
    value: null,
};

export const latLonOperators: Operator[] = [
    // -- you can't filter by count as an operator because count is the aggregation
    // --  not the filter which occurs before aggregation
    // {
    //     display: 'Count',
    //     apiSymbol: 'count',
    //     value: 'count'
    // }
];

export const numericalOperators: Operator[] = [
    {
        display: 'Less than',
        apiSymbol: 'lt',
        value: '<',
    },
    {
        display: 'Greater than',
        apiSymbol: 'gt',
        value: '>',
    },
    {
        display: 'Does not equal',
        apiSymbol: 'ne',
        value: '!==',
    },
    {
        display: 'Less than or equal to',
        apiSymbol: 'lte',
        value: '<=',
    },
    {
        display: 'Greater than or equal to',
        apiSymbol: 'gte',
        value: '>=',
    },
    {
        display: 'Is equal to',
        apiSymbol: '',
        value: '===',
    },
    showAll,
];

export const stringOperators: Operator[] = [
    {
        display: 'Is equal to',
        apiSymbol: '',
        value: '===',
    },
    {
        display: 'Does not equal',
        apiSymbol: 'ne',
        value: '!==',
    },
    {
        display: 'Contains',
        apiSymbol: 'c',
        value: 'LIKE',
    },
    {
        display: 'Does not contain',
        apiSymbol: 'nc',
        value: 'NOT LIKE',
    },
    {
        display: 'Matches pattern',
        apiSymbol: 'p',
        value: 'LIKE',
    },
    {
        display: 'Does not match pattern',
        apiSymbol: 'np',
        value: 'NOT LIKE',
    },
    showAll,
];

export const objectTypeOperators: Operator[] = [
    {
        display: 'Is equal to',
        apiSymbol: '',
        value: '===',
    },
    {
        display: 'Does not equal',
        apiSymbol: 'ne',
        value: '!==',
    },
    showAll,
];
